import { CustomShape } from '@statsbomb/kitbag-datavis';

export const pitchZonesToCoords = (zones: CustomShape[]) =>
  zones.map(zone => {
    const [start, _, end] = zone.points.split(' ');
    return `${start},${end}`;
  });
